/**
 * Currency enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Currency = {
	CZK: "CZK",
	EUR: "EUR",
	RON: "RON",
};

/**
 * Tariff component type enum
 * @enum string
 * @readonly
 */
export const E_Tariff_ComponentType = {
	FLAT: "FLAT",
	TIME_MINUTE: "TIME_MINUTE",
	MINIMUM_PRICE: "MINIMUM_PRICE",
	FORMULA: "FORMULA",
};
